module.exports = __webpack_public_path__ + "ed42d5e41d59e9afed86591016e9a170.png";